import { render, staticRenderFns } from "./CopyValues.vue?vue&type=template&id=47192081&"
import script from "./CopyValues.vue?vue&type=script&lang=js&"
export * from "./CopyValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports